export const SexoColaborador = Object.freeze({
    FEMENINO: "FEMENINO",
    MASCULINO: "MASCULINO",    
});